import { Component, input, ViewEncapsulation } from "@angular/core";
import { VdsIconComponent } from "@cce/design-system/icon";

@Component({
    selector: "a[vds-text-link]",
    templateUrl: "./text-link.component.html",
    styleUrl: "./text-link.component.css",
    encapsulation: ViewEncapsulation.None,
    host: {
        class: "vds-text-link"
    },
    imports: [VdsIconComponent]
})
export class VdsTextLinkComponent {
    leadingIcon = input<string | undefined>(undefined);
    trailingIcon = input<string | undefined>(undefined);
}
